"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var jobs_1 = require("../routes/jobs");
var fetch_1 = require("../utils/fetch");
var transform_1 = require("../utils/transform");
exports.default = {
    jobs: function (queryParams) {
        return fetch_1.default("/jobs", {
            method: "GET",
        }, queryParams);
    },
    fetchExternalJobs: function (query) {
        return fetch_1.default("/jobs/external", {
            method: "GET",
        }, query);
    },
    jobsAvailable: function (queryParams) {
        var _a = jobs_1.default.jobsAvailable, url = _a.url, method = _a.method;
        return fetch_1.default(url, {
            method: method,
        }, queryParams);
    },
    createJobOffer: function (jobInput) {
        var _a = jobs_1.default.createJobOffer, url = _a.url, method = _a.method;
        var body = transform_1.toSnakeCase(jobInput);
        return fetch_1.default(url, {
            method: method,
            body: JSON.stringify(body),
        });
    },
    myJobs: function (queryParams) {
        var _a = jobs_1.default.myJobs, url = _a.url, method = _a.method;
        return fetch_1.default(url, {
            method: method,
        }, queryParams);
    },
    job: function (id) {
        return fetch_1.default("/jobs/" + id, {
            method: "GET",
        });
    },
    banJob: function (id) {
        return fetch_1.default("/jobs/" + id + "/ban", {
            method: "POST",
        });
    },
    jobStats: function (id) {
        var _a = jobs_1.default.jobStats, url = _a.url, method = _a.method;
        var newUrl = lodash_1.replace(url, "{id}", id.toString());
        return fetch_1.default(newUrl, {
            method: method,
        });
    },
    jobAction: function (id, action) {
        var _a = jobs_1.default.jobAction, url = _a.url, method = _a.method;
        var newUrl = lodash_1.replace(url, "{id}", id.toString());
        newUrl = lodash_1.replace(newUrl, "{action}", action);
        return fetch_1.default(newUrl, {
            method: method,
        });
    },
};
//# sourceMappingURL=jobs.js.map